import { CobaltFlagMessage } from '@cae/cobalt-react/components/flag-message';
import {
  CobaltLayout,
  CobaltLayoutContent,
  CobaltLayoutHeader,
} from '@cae/cobalt-react/components/layout';
import { AppHeader } from '@layouts/components/app-header/AppHeader';
import * as React from 'react';

import type { HeaderOnlyLayoutProps } from './HeaderOnlyLayout.types';

/**
 * Layout with header only (no side navigation).
 *
 * Used by route guards (ModuleGuard, OrgRouteGuard) to display error content
 * when an authenticated user accesses a route they don't have permission for.
 * Shows the app header so the user can navigate away, without the side nav.
 */
const HeaderOnlyLayout = React.memo(
  ({ children }: Readonly<HeaderOnlyLayoutProps>): React.ReactElement => {
    return (
      <>
        <CobaltFlagMessage />
        <CobaltLayout>
          <CobaltLayoutHeader>
            <AppHeader hasSideNavigation={false} />
          </CobaltLayoutHeader>

          <CobaltLayoutContent>{children}</CobaltLayoutContent>
        </CobaltLayout>
      </>
    );
  }
);

HeaderOnlyLayout.displayName = 'HeaderOnlyLayout';

export { HeaderOnlyLayout };
